var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.algoValue)?_c('md-avatar',{staticClass:"md-avatar-icon md-small icon-inline"},[_c('md-icon',[_vm._v("error_outline")]),_c('md-tooltip',{attrs:{"md-direction":"right"}},[_vm._v("Algorithm value: "+_vm._s(_vm.algoValue))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }